export default __webpack_public_path__ + "static/media/about-4.6b19d956.jpg";